import * as S from './Continue.styles';
export const Continue = S.Root;